import React, { useState } from 'react';
import {
    Background,
    Container,
    Input,
    CloseIcon,
    Image,
    RemoveIcon,
    ImageContainer,
    Button,
    CameraIcon,
    CameraInput,
    CameraContainer,
} from './style';
import InputLabel from '../InputLabel';
import PdfImage from '../../assets/images/pdf.png';
import XlsImage from '../../assets/images/xls.png';
import { Swal, Toast } from '../../services/SwalTemplates';
import api from '../../services/api';

export default function FileInput({
    Show,
    setShow,
    NumProcesso,
    IdProcesso,
    Seq,
    Nivel,
    setRealodData,
    setAnexo,
    Anexo,
    Origin,
    IdAgendamento,
    Assunto,
    setAssunto,
}) {
    const [NomeArquivo, setNomeArquivo] = useState('');
    const [Tipo, setTipo] = useState('');
    const [File, setFile] = useState('');
    const [FileImg, setFileImg] = useState('');
    const [HighlightInput, setHighlightInput] = useState(false);

    async function HandleSubmit(e) {
        e.preventDefault();

        const data = {
            seq_ocorrencia: null,
            nivel_ocorrencia: null,
            titulo_documento: Assunto,
            processo: NumProcesso,
            id_processo: IdProcesso,
        };
        if (Origin === 'Anexo') {
            data.seq_ocorrencia = Seq;
            data.nivel_ocorrencia = Nivel;
        }

        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });
        formData.append('assunto_documento', Assunto);
        formData.append('file', File);

        const config = {
            headers: { 'content-type': 'multipart/form-data' },
        };

        if (Origin === 'Anexo') {
            api.post(`/anexos`, formData, config)
                .then((response) => {
                    Toast.fire({
                        title: response?.data?.success,
                        icon: 'success',
                    });
                    setRealodData((rd) => !rd);
                })
                .catch((e) => {
                    Swal.fire({ title: 'Atenção!', text: e, icon: 'error' });
                });
        } else if (Origin === 'Ocorrencia') {
            setAnexo(File);
        } else if (Origin === 'Agendamento') {
            const data1 = {
                id_agendamento: IdAgendamento,
                titulo_anexo: Assunto,
            };

            const formData1 = new FormData();

            Object.keys(data1).forEach((key) => {
                formData1.append(key, data1[key]);
            });
            formData1.append('file', File);

            setAnexo(formData1);
        } else if (Origin === 'AnexoAgendamento') {
            const data2 = {
                id_agendamento: IdAgendamento,
                titulo_anexo: Assunto,
            };

            const formData2 = new FormData();

            Object.keys(data2).forEach((key) => {
                formData2.append(key, data2[key]);
            });
            formData2.append('file', File);

            api.post(`/anexos/agendamentos`, formData2, config)
                .then((response) => {
                    Toast.fire({
                        title: response?.data?.success,
                        icon: 'success',
                    });
                })
                .catch((e) => {
                    Swal.fire({ title: 'Atenção!', text: e, icon: 'error' });
                });
        }

        setShow(false);
    }

    async function Close() {
        setShow(false);
        setNomeArquivo('');
        setTipo('');
        setFile('');
        setAssunto('');
    }

    return (
        <Background Show={Show}>
            <Container>
                <CloseIcon onClick={() => Close()} />
                {File ? (
                    <>
                        <ImageContainer>
                            <RemoveIcon onClick={() => setFile('')} />
                            <Image
                                src={Tipo.includes('image') ? FileImg : Tipo.includes('pdf') ? PdfImage : Tipo.includes('sheet') ? XlsImage : ''}
                                alt="Erro"
                            />
                        </ImageContainer>
                        <InputLabel type="text" label="Nome Arquivo" disabled value={NomeArquivo} required />
                        <InputLabel required type="text" label="Assunto" value={Assunto} onChange={(e) => setAssunto(e.target.value)} />
                        <Button type="submit" onClick={HandleSubmit} disabled={!Assunto}>
                            ANEXAR
                        </Button>
                    </>
                ) : (
                    <>
                        <CameraContainer>
                            <CameraInput
                                type="file"
                                accept="image/*"
                                name="image"
                                onChange={(e) => {
                                    if (
                                        e?.target?.files[0]?.type.includes('image') ||
                                        e?.target?.files[0]?.type.includes('pdf') ||
                                        e?.target?.files[0]?.type.includes('sheet')
                                    ) {
                                        setFileImg(URL.createObjectURL(e?.target?.files[0]));
                                        setFile(e?.target?.files[0]);
                                        setTipo(e?.target?.files[0]?.type);
                                        setNomeArquivo(e?.target?.files[0]?.name);
                                    } else {
                                        Swal.fire({
                                            title: 'Atenção!',
                                            text: 'Formato não permitido!',
                                            icon: 'warning',
                                        });
                                    }
                                }}
                                capture
                            />
                            <CameraIcon />
                        </CameraContainer>
                        <Input
                            type="file"
                            accept="image/*,.pdf,.xlsx"
                            onDragEnter={() => {
                                setHighlightInput(true);
                            }}
                            HighlightInput={HighlightInput}
                            onDragLeave={() => {
                                setHighlightInput(false);
                            }}
                            onDrop={() => {
                                setHighlightInput(false);
                            }}
                            onChange={(e) => {
                                if (
                                    e?.target?.files[0]?.type.includes('image') ||
                                    e?.target?.files[0]?.type.includes('pdf') ||
                                    e?.target?.files[0]?.type.includes('sheet')
                                ) {
                                    setFileImg(URL.createObjectURL(e?.target?.files[0]));
                                    setFile(e?.target?.files[0]);
                                    setTipo(e?.target?.files[0]?.type);
                                    setNomeArquivo(e?.target?.files[0]?.name);
                                } else {
                                    Swal.fire({
                                        title: 'Atenção!',
                                        text: 'Formato não permitido!',
                                        icon: 'warning',
                                    });
                                }
                            }}
                        />
                    </>
                )}
            </Container>
        </Background>
    );
}
